<template>
  <div>
    <b-table
      v-if="!isBusy"
      responsive="sm"
      :fields="fields"
      :items="items"
      table-class="table-head-custom table-vertical-center mt-5"
      show-empty
      :busy="isBusy"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>

      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>

      <template v-slot:cell(name)="data">
        <div class="d-flex flex-column">
          <span class="font-weight-bolder text-h6">
            {{ data.item.leave_name }}
          </span>
        </div>
      </template>

      <template v-slot:cell(assign)="data">
        <div class="d-flex flex-row justify-content-left">
          <!-- begin::: edit-details button -->
          <button
            class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
            v-on:click="showModal(data.item)"
            v-b-tooltip.hover="$t('LEAVE.HOVER.ASSIGNLEAVE')"
          >
            <span class="svg-icon svg-icon-primary menu-icon">
              <inline-svg src="/media/svg/icons/Navigation/Check.svg" />
            </span>
          </button>
          <!-- end::: edit-details button -->
        </div>
      </template>

      <template #table-busy>
        <AppLoader #table-busy></AppLoader>
      </template>
    </b-table>
    <CompanyEmployeeLeaveAssignmentModal></CompanyEmployeeLeaveAssignmentModal>

    <div v-if="isBusy" class="d-flex my-8">
      <b-skeleton-table
        :rows="5"
        :columns="5"
        :table-props="{ bordered: true, striped: false }"
      ></b-skeleton-table>
    </div>

    <div class="d-flex justify-content-end" v-if="items.length && !isBusy">
      <b-pagination
        pills
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        aria-controls="leave-entitlement-page-dt"
        @change="handlePageChange"
        size="lg"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import { mapGetters } from "vuex";
import CompanyEmployeeLeaveAssignmentModal from "@/modules/company/components/leave/assignment/employee/form/CompanyEmployeeLeaveAssignmentModal";
export default {
  name: "CompanyEmployeeLeaveAssignmentPageTable",
  components: { CompanyEmployeeLeaveAssignmentModal, AppLoader },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: this.$t("ENTITLEMENT.TYPE") },
        { key: "unit_entitled", label: this.$t("ENTITLEMENT.DAYS") },
        { key: "balance", label: this.$t("ENTITLEMENT.BALANCE") },
        { key: "assign", label: "Assign" },
      ],
      isBusy: false,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.isBusy = true;

      const id = this.$route.query.id;
      this.$store
        .dispatch("fetchEmployeeLeaveAssignmentList", id)
        .catch(() =>
          this.$bvModal.msgBoxOk("Not OK!", {
            centered: true,
          })
        )
        .finally(() => (this.isBusy = false));
    },
    refresh() {
      this.fetch();
    },
    handlePageChange(value) {
      console.log(value);
      this.$store.commit("setEmployeeLeaveAssignmentListPage", value);
      this.fetch();
    },
    showModal(data) {
      console.log("Selected Leave ", data);
      this.$store.dispatch("assignEmployeeLeaveAssignment", data);
      this.$store.dispatch("assignEmployeeAssignmentFormIsSaved", false);
      this.$bvModal.show("company-employee-leave-assignment-modal");
    },
  },
  computed: {
    ...mapGetters({
      items: "getEmployeeLeaveAssignment",
      employee: "getSelectedAssignForEmployee",
      pagination: "getEmployeeLeaveAssignmentPagination",
    }),
  },
  watch: {
    reload() {
      console.log("Reload Table!");
      this.fetch();
    },
  },
};
</script>

<style scoped></style>
